import { defineNuxtRouteMiddleware, useNuxtApp } from '#imports';
import storeLogoutRedirect from '~/utils/storeLogoutRedirect';

export default defineNuxtRouteMiddleware((to, from) => {
  storeLogoutRedirect(useNuxtApp().$auth?.$storage, from.path);
});
